/**
 * URL for a file served from `public/` (same behavior as CRA `PUBLIC_URL` + path).
 * Matches `import.meta.env.BASE_URL` from Vite (`./` when `base: './'`).
 */
export function publicAssetUrl(relativePath: string): string {
    const base = import.meta.env.BASE_URL;
    const normalized = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;
    return `${base}${normalized}`;
}
